// extracted by css-extract-rspack-plugin
export default {"userProfileModal":"WS1ITY80wu0R8KtR","content":"I6lrMsKizsEHphGA","title":"cBcWBXVIn8ct7aMG","footer":"HbR7bkY64MQj3oY6","divider":"MgKBW4lcaik_GTk7","buttons":"y6KYbxEbatI50moO"};